import React from "react";
import HourlyStats from "@client/components/valueDisplays/HourlyStats";
import DailyHistory from "@client/components/valueDisplays/Stats";

interface Props {
  topicId: string;
  boolean?: boolean;
  hourly?: boolean;
}

export const StatsWidget: React.FC<Props> = ({ topicId, boolean: isBoolean = false, hourly = false }) =>
  hourly ? (
    <HourlyStats topicId={topicId} boolean={isBoolean} />
  ) : (
    <DailyHistory topicId={topicId} boolean={isBoolean} />
  );

export default React.memo(StatsWidget);
